import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { LanguageProvider } from './context/LanguageContext'


function App() {
  return (
    <LanguageProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </LanguageProvider>
  )
}

export default App